// Orchestrateur des animations au scroll.
// Init après document.fonts.ready (évite le reflow texte mid-animation),
// refresh ScrollTrigger après window.load (recalcul des positions une fois
// images/vidéos chargées). Expose window.PDW pour la re-init dynamique (preview ACF, AJAX).
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initDataAnim } from "./anim_data_anim";

function initAllAnimations( scope = document ) {
    initDataAnim( scope );
}

document.addEventListener( "DOMContentLoaded", () => {
    document.fonts.ready.then( () => {
        initAllAnimations();
    } );
} );

window.addEventListener( "load", () => {
    requestAnimationFrame( () => ScrollTrigger.refresh() );
} );

// API globale pour ré-initialiser après injection de contenu dynamique.
window.PDW = window.PDW || {};
window.PDW.gsap = gsap;
window.PDW.initAllAnimations = initAllAnimations;
window.PDW.refreshAllAnimations = () => ScrollTrigger.refresh();
